import { render, staticRenderFns } from "./StudentPausedCourses.vue?vue&type=template&id=37ab60a4"
import script from "./StudentPausedCourses.vue?vue&type=script&lang=ts"
export * from "./StudentPausedCourses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports